import config from '@packages/config';
import { getStaticBucketUrl, UrlType } from './apiUrl.staticPage';
import { fetcher } from './fetcher';

const getEndpoint = (bucketUrl: string, pathname: string, locale: string) =>
  getStaticBucketUrl({
    bucketUrl,
    pathname,
    language: locale.substring(0, 2),
    type: UrlType.PAGE,
  });

/**
 * fetch data from static endpoint like google bucket
 * If fetch is failing an error is thrown
 *
 * @param bucketUrl
 * @param pathname
 * @param locale
 * @param type
 * @returns data from bucket as json
 */
const cmsFetcher = async <T>({
  pathname = '/',
  bucketUrl,
  locale = 'de-DE',
  type = UrlType.PAGE,
  revisionId,
}: {
  pathname?: string | string[];
  bucketUrl?: string;
  locale?: string;
  type?: UrlType;
  revisionId?: string;
}) => {
  if (type === UrlType.PREVIEW && Array.isArray(pathname)) {
    // prepare correct pathName of content-json to request from cms
    pathname.splice(0, 1);
    // find and remove the revisionId-path-segment from pathname (was optional added by the middleware)
    const drupalPreviewFetchUrl = `${config.staticContent.apiEndpoints.webappJson
      .replace('<envTld>', process.env.ENVIRONMENT === 'staging' ? 'dev' : 'cloud')
      .replace('<locale>', locale.substring(0, 2))
      .replace('<path>', pathname.join('/'))}${revisionId ? `&revisionId=${revisionId}` : ''}`;
    const drupalPreviewFetchHeaders = {
      ...(process.env.EMPDEV_AUTH && { 'empdev-auth': process.env.EMPDEV_AUTH }),
      'User-Agent': `fetch/static-content-app-preview`,
      ...(process.env.DRUPAL_PREVIEW_AUTH && {
        Authorization: `Basic ${process.env.DRUPAL_PREVIEW_AUTH}`,
      }),
    };
    return fetcher<T>(drupalPreviewFetchUrl, undefined, drupalPreviewFetchHeaders);
  }
  if (bucketUrl) {
    // prepare correct pathName of content-json to request from bucket
    const fileName =
      Array.isArray(pathname) && pathname
        ? pathname
            ?.filter((pathSegment: string) => !pathSegment.match(/de|fr|storefront/))
            ?.join('-')
        : pathname || '/';
    // Assemble the final url to be fetched
    const apiCmsUrlStaticFileCms = getStaticBucketUrl({
      bucketUrl,
      pathname: fileName,
      language: locale.substring(0, 2),
      type,
      menu: type === UrlType.MENU ? fileName : undefined,
    });

    return fetcher<T>(apiCmsUrlStaticFileCms);
  }
  return null;
};

export { cmsFetcher, getEndpoint };
